var _ = require('underscore');

/**
 * 商品和单位的对应表
 */
var units = {
    air: "套",
    hotel: "间",
    tour: "份",
    train: "张",
    car: "辆",
    pickup: "辆",
    visa: "份",
    insurance: "份",
    wifi: "台"
};

var productDescribeGetter = {
    get_pid(item){
      return item.pid;
    },
    get_name(item){

        var name = item.name;

        if (!item.attr) {

            return name;
        }

        name = item.attr.short || item.name || item.attr.long;

        return name;

    },
    get_fullName(item){

        var name = item.name;

        if (!item.attr) {

            return name;
        }

        name = item.name || item.attr.long;

        return name;

    },
    get_day(item){

        var days = (item.use_day + '').split(',');
        var dayStr = +days[0]>0 ? `DAY ${+days[0]}` : "";

        if (days.length > 1) {
            dayStr = dayStr + `-${+days[0] + days.length - 1}`
        }

        return  dayStr;

    },

    get_num(item, productType){

        var unitName = !productType ? "" : units[productType] || "";
        var cnt = item.cnt;

        if(productType === "wifi"){
            cnt = 1;
        }
        if(item.name.indexOf("安联租车") >=0 ){
            unitName = "天"
        }

        return cnt ? cnt + unitName : null

    },
    get_extra(item){
        if( _.isArray(item.extra) ){
            return item.extra[0];
        }
        return item.extra
    },
    get_remarks(item){

        var remarks = item.attr.remarks || [];
        return  remarks

    },
    get_notices(item){
        if(item.notices_to_user){
            var notices = item.notices_to_user.length==0 ? null : item.notices_to_user ;
        }else{
            var notices = null;
        }

        return notices
    },
    get_person(item){
        if(item.person_info){
            var person = item.person_info.length==0 ? null : item.person_info ;
        }else{
            var person = null;
        }

        return person
    },
    get_name_tags(item){
        if(item.name_tags){
            var name_tags = item.name_tags.length==0 ? null : item.name_tags;
        }else{
            var name_tags = null;
        }

        return name_tags;
    }

}

/**
 * 获取产品名称
 * @param {object} item - 商品数据
 * @param {[string]} productType - 商品类目名称[可选] (num 时需要单位则要用到此参数)
 * @return {object} 商品描述对象
 *
 */
var get_productDescribe = function(item, productType) {

    return _.reduce(productDescribeGetter,(memo, method, name)=>{

        memo[name.replace('get_','')] = method(item,productType);
       
        return memo

    },{})
};
/**
 * 获取产品列表
 * @param {array} items - 商品数据列表
 * @param {[string]} productType - 商品类目名称
 * @return {array} 商品描述对象列表
 */
var get_productDescribeList = function(items, productType){
    return items.map(item=> {
        return get_productDescribe(item,productType)
    })
};

module.exports = {
    productDescribeGetter,
    get_productDescribe,
    get_productDescribeList
};



/** WEBPACK FOOTER **
 ** ./script/util/productDescribeService.js
 **/